import { render, staticRenderFns } from "./imageTextBox.vue?vue&type=template&id=87ac18ec&"
import script from "./imageTextBox.vue?vue&type=script&lang=js&"
export * from "./imageTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports